import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import Conversas from "./Conversas/Conversas"; // 👈 importa o componente

export default function Whatsapp() {
  return (
    <div className="px-8 mt-14">
      <h2
        style={{
          fontFamily: "Comfortaa, cursive",
          fontSize: "1.8rem",
          color: "#454545",
          fontWeight: "600",
          marginBottom: "0.6rem",
          display: "flex",
          alignItems: "center",
          gap: "0.6rem",
        }}
      >
        <FaWhatsapp style={{ color: "#25D366" }} /> Conversas WhatsApp
      </h2>

      {/* Linha separadora */}
      <div
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: "#d0d0d0",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          marginBottom: "1rem",
        }}
      ></div>

      {/* Chama o componente de conversas aqui */}
      <Conversas />
    </div>
  );
}
